<script lang="ts">
    export let title = "";
    export let val = NaN;
    export let enable = true;
    export let autoDisable = false;
    export let decimalFix = 4;
    export let wholeFix = 1;
    $: minWidthVar = `min-width: ${decimalFix + 1}em;`;
    let dislayedTempreture;
    $: dislayedTempreture = paddTemp(val);

    function click() {}
    function paddTemp(temp) {
        if (val === null || val === undefined || isNaN(val)) {
            if (autoDisable) {
                enable = false;
            }
            return null;
        }
        if (autoDisable) {
            enable = true;
        }
        // const wholePartLen = temp.toString().split(".")[0];
        return temp
            .toFixed(decimalFix)
            .padStart(decimalFix + 1 + wholeFix, "0");
    }
</script>

<div class="root" on:click={click}>
    {#if !enable}
        <div class="overlay" />
    {/if}
    <div class="nameWrap">
        <span class="name">{title}</span>
        <!--   <CheckBox bind:enable disableUserControl={true}/> -->

        <!-- <div class="checkbox" style="z-index: 10;">
            {#if enabled}
                <span class="material-icons"> done </span>
            {/if}
            <input type="checkbox" bind:checked={enabled} name="enable" />
        </div> -->
    </div>
    <div class="value" style={minWidthVar}>
        {#if val === null}
            <span>--</span>
        {:else}
            <span>{dislayedTempreture}°C</span>
        {/if}
    </div>
</div>

<style>
    .root {
        position: relative;
        background: var(--back);
        padding: 0.7rem 1rem;
        width: fit-content;
        border: solid var(--back_D12) 1px;
        /* box-shadow: 2px 2px 3px 0px var(--back_D2),
            2px 2px 5px 2px var(--back_D1); */
    }
    .name {
        color: var(--back_D2);
        font-size: 1.1rem;
        font-weight: 300;
        margin: 0;
        margin-right: 1rem;
        user-select: all;
    }
    .nameWrap {
        margin-bottom: 0.5rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    /* .checkbox {
        display: inline-grid;
        width: 1em;
        height: 1em;
        border-radius: 20%;
        border: 1px solid var(--prim);
        background: #eee;
    }
    .checkbox input {
        opacity: 0;
        margin-bottom: 0;
        width: 1em;
        height: 1em;
    }
    .checkbox > .material-icons {
        font-size: 1rem;
        font-weight: bold;
        color: var(--prim);
    } */
    .overlay {
        opacity: 0.7;
        background: var(--back_D15);
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
    }
    .value {
        margin: 0.5rem 5px;
        font-size: 1.3rem;
        font-weight: 600;
        border-left: solid var(--prim) 2px;
        padding-left: 5px;
    }
</style>
